/*行业直播接口*/
import axios from "../index";
import api from "./Application.api";

export default {
    /**
     * 查询行业直播列表  @data "videoName":"搜索关键字" ;"pageNum":"1" ;  "pageSize":"10"
     */
    getTradeVideoList(data = {}) {
        return axios.post(api.getTradeVideoList, data);
    },
    /**
     * 根据视频id查询详细信息  @data "videoId": "视频id" ;
     */
    getTradeVideoByVideoId(data = {}) {
        return axios.post(api.getTradeVideoByVideoId, data);
    }
}